import React from 'react';

const BtcConnect = () => {
  return null;
};

export default BtcConnect;
